import {
  type PreventCommands,
  Router,
  type RouterLocation,
} from "@vaadin/router";
import { LitElement } from "lit";
import type { OpenModalEvent } from "./events";
import { appRouter } from "./router";
import { urlPathToNugetId } from "./functions";

export class CanOpenPackageElement extends LitElement {
  onBeforeLeave(
    location: RouterLocation,
    commands: PreventCommands,
    _: Router
  ) {
    // if navigating to a package page, the param wont exist but will
    // be available on the url instead
    let packageId: string | undefined =
      appRouter?.location.params.packageId?.toString();
    if (location.pathname.startsWith("/package/")) {
      packageId = urlPathToNugetId(location.pathname);
    }

    if (packageId) {
      this.dispatchOpenModalEvent(
        packageId,
        false,
        appRouter?.location.params.iconDominantColor?.toString()
      );

      // eslint-disable-next-line consistent-return
      return commands.prevent();
    }

    return;
  }

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  dispatchOpenModalEvent(
    packageId: string,
    direct: boolean,
    iconDominantColor?: string
  ) {
    this.dispatchEvent(
      new CustomEvent<OpenModalEvent>("open-modal", {
        bubbles: true,
        composed: true,
        detail: {
          packageId,
          direct,
          iconDominantColor,
        },
      })
    );
  }
}
